import { DesignProp, GeneralProp } from "../PropCategories";

export const fontSize = {
  prop: "style-attribute",
  name: "Font Size",
  nameI18n: "builder_ui.prop_type.styles.font_size",
  category: [DesignProp, GeneralProp],
  type: "slider",
  defaultValue: "16px",
  sliderProps: {
    units: ["rem", "px"],
    step: 0.5,
    defaultUnit: "rem",
    min: 1,
    max: 120,
  },
} as const;
